// extracted by mini-css-extract-plugin
module.exports = {"warning":"AddScreenForm_warning__2S0Md","input":"AddScreenForm_input__3x16I","addScreenFormStyle":"AddScreenForm_addScreenFormStyle__3WboS"};